module.exports = __webpack_public_path__ + "img/RBS04_5_loading.51748cb8.jpg";